<div class="modal-body">
  <div class="content">
    <div class="top">
      <h4 translate>marketing.offer-link.add-metadata-explaination-popup.title</h4>
      <button type="button" class="close" aria-label="Close" (click)="close()">
        <i class="icon-small-close"></i>
      </button>
    </div>
    <ul>
      <li translate>marketing.offer-link.add-metadata-explaination-popup.list.1</li>
      <li translate>marketing.offer-link.add-metadata-explaination-popup.list.2</li>
      <li translate>marketing.offer-link.add-metadata-explaination-popup.list.3</li>
      <li translate>marketing.offer-link.add-metadata-explaination-popup.list.4</li>
    </ul>
    <img src="assets/img/how-to-add-metadata-to-coupon.png" alt="" class="img">
    <div class="buttons-container">
      <button class="vox-btn vox-btn-secondary-dark-grey" (click)="close()"
        translate>marketing.offer-link.add-metadata-explaination-popup.close</button>
    </div>
  </div>
</div>